import { createFileRoute } from "@tanstack/react-router";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { ResidentsTab } from "@/routes/_authenticated/community/-components/residents-tab";
import { useCommunityBuilding } from "@/routes/_authenticated/community/-components/use-community-building";

export const Route = createFileRoute("/_authenticated/community/residents")({
  component: ResidentsPage,
});

/** Each resident's photo consent, for what the community may show of them. */
function ResidentsPage() {
  const { building, canModerate, canManage } = useCommunityBuilding();
  if (!building) return null;
  return (
    <>
      <PageHeader title="Photo consent" />
      {canModerate || canManage ? (
        <ResidentsTab facilityId={building.id} canManage={canManage} />
      ) : (
        <EmptyState
          title="Not open to you"
          description="Residents' photo consent is for the people who run the community at this building."
        />
      )}
    </>
  );
}
